<template>
  <div class="container">
    <div class="oferta-container">
      <wrap-container class="grid-container grid-container--6-6">
        <wrap-container class="col2 image-container">
          <img
            class="image"
            src="@/assets/img/ofertaNomina/mobile.png"
            alt="Celular"
          />
        </wrap-container>
        <wrap-container class="col1 padding-17-left-right">
          <span class="titles">
            <p id="titulo" class="titulo p28 oscuro">
              ¡Hola <span data-obfuscate>{{ nombre }}</span
              >!
            </p>
            <p id="subtitulo" class="titulo p32 oscuro medium">
              Ingresá en Banca Online y conocé el regalo de bienvenida que
              tenemos para vos
            </p>
          </span>
          <wrap-container>
            <p class="description">
              Además, contás con estos beneficios por cobrar tu sueldo en BBVA
            </p>
            <offer-group class="offer-group" item-icon="check">
              <offer-element
                v-for="inc in beneficios"
                v-bind:key="inc.label"
                :label="inc.label"
                :description="inc.description"
                :labelLight="true"
              />
            </offer-group>
          </wrap-container>
          <sales-button
            class="sales-button"
            ref="salesbutton"
            label="Ingresar a Banca Online"
            @click.native="goToHomeBanking"
            color="#1973b8"
          />
        </wrap-container>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import OfferGroup from "@/components/core/OfferGroup";
import OfferElement from "@/components/core/OfferElement";
import SalesButton from "@/components/core/SalesButton";
import { DO_INGRESO_BANCA_ONLINE } from "../config/constants/action-types";

export default {
  name: "Cliente",
  components: {
    WrapContainer,
    OfferGroup,
    OfferElement,
    SalesButton
  },
  data() {
    return {
      beneficios: [
        {
          label: "Cuenta bonificada"
        },
        {
          label: "Gestión de trámite 100% online."
        },
        {
          label: "Condiciones y tasas preferenciales en préstamos personales."
        }
      ]
    };
  },
  methods: {
    goToHomeBanking() {
      this.$store.dispatch(DO_INGRESO_BANCA_ONLINE);
      window.open(
        "https://online.bbva.com.ar/fnetcore/loginClementeApp.html?init=nc",
        "_blank",
        "noopener"
      );
    }
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    }
  }
};
</script>
<style scoped>
.container {
  margin-top: 20px;
  margin-bottom: 50px;
}
div.container {
  height: 100%;
}
.oferta-container {
  max-width: 1200px;
  margin: 0 auto;
}
p {
  margin-top: 0px;
  margin-bottom: 0px;
}
p#titulo {
  margin-bottom: 8px;
}
p#subtitulo {
  margin-bottom: 0px;
  max-width: 500px;
}
.image {
  display: block;
  margin-bottom: 8px;
  float: right;
  margin-right: 17px;
}
.description {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: -0.29px;
  color: #121212;
  margin-bottom: 32px;
  margin-top: 16px;
}
.sales-button {
  margin-bottom: 32px;
  width: 216px;
}
@media screen and (max-width: 899px) {
  .image {
    width: 300px;
  }
}
@media screen and (max-width: 599px) {
  .container {
    margin-top: 0px;
  }
  #titulo {
    font-size: 20px;
    margin-bottom: 8px;
  }
  #subtitulo {
    font-size: 26px;
    margin-bottom: 4px;
  }
  .image {
    float: none;
    height: 150px;
    width: auto;
    margin-left: calc(50% - 87px);
    background-color: aqua;
    margin-top: -30px;
  }
  .image-container {
    background-color: #cae8fc;
  }
  .description {
    width: 100%;
    margin-bottom: 24px;
  }
  .offer-group {
    margin-top: 32px;
  }
  .titles {
    display: inline;
  }
  .sales-button.container {
    padding-bottom: 17px;
    padding-top: 17px;
  }

  .sales-button {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    bottom: 0;
    right: 0;
    width: 100%;
    background: white;
  }
}
</style>
